import { useRouter } from 'next/router';

import { DEVICE_GALLERY_PAGE } from 'shared/constants';
import { useSegment } from 'shared/hooks';
import { useIsWebView } from 'shared/providers/isWebView';
import { getPath } from 'shared/utils';

/**
 * Should be used to wrap any redirect outside of the Next app. WebView can not leave the Next app
 * so any cases where this occurs, you should provide an alternative callback for WebView mode or it
 * will default to redirecting to the shop index.
 *
 * @deprecated use useShopRouter instead
 */
export default function useWithWebViewRedirectProtection(
  callback: () => void,
  webViewAlternative?: () => void,
): () => void {
  const router = useRouter();
  const isWebView = useIsWebView();
  const { channel } = useSegment();

  if (isWebView) {
    if (webViewAlternative && typeof webViewAlternative === 'function') {
      return webViewAlternative;
    }
    return () => router.push(getPath(DEVICE_GALLERY_PAGE, channel));
  }

  return callback;
}
